<section class="sct-forma-pago banner-padding">
  <div class="container">
    <div class="row sub-headers-inside sub-inside">
      <div class="col-12 m-auto text-center">
        <div class="overlap-signature header-inside">
          <span class="letter"> <span class="signature-text">Formas de</span></span>
          <h1 class="main-text">pago</h1>
        </div>
      </div>
    </div>
  </div>
</section>


<section class="section-payment">
  <div class="container" data-aos="fade-right">
    <div class="row container-pago">

      <!-- Timer -->
      <div class="col-md-12 text-center">
        <div id="timer" class="content-minute">
          <div [hidden]="(st.minutesDisplay == 0 && st.secondsDisplay == 0) || boletos.length == 0 || tipos_pago == 2 || tipos_pago == 3 || st.pagoEnProceso"></div>
          <div [hidden]="(st.minutesDisplay == 0 && st.secondsDisplay == 0) || boletos.length == 0 || tipos_pago == 2 || tipos_pago == 3 || st.pagoEnProceso">
            <i class="fa fa-clock-o" aria-hidden="true"></i>
            <!-- Ojo: antes decía "minutesDisplay <= 59", y como la reserva se extiende a 60
                 minutos el contador mostraba 00:00 justo al empezar a pagar. Ahora solo se
                 valida que sea positivo, así 60 se pinta bien. -->
            <span class="timeres">
              {{ st.minutesDisplay > 0 ? st.minutesDisplay : '00' }} : {{ st.secondsDisplay &&
                st.secondsDisplay <=59 ? st.secondsDisplay < 10 ? '0' + st.secondsDisplay : st.secondsDisplay : '00' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Aviso del guard anti-pago-doble (venta digital) -->
      <div class="col-12" *ngIf="bloqueoPagoMsg">
        <div class="alert alert-warning text-center" role="alert" style="border-radius:10px;">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>&nbsp;{{ bloqueoPagoMsg }}
        </div>
      </div>

      <!-- ===== PASO 1: ELEGIR MÉTODO (izquierda) =====
           Elegir una card NO genera la orden: se puede cambiar libremente hasta presionar el
           botón del resumen (continuarConMetodo -> pagoIniciado). Desde ahí es irreversible.
           Cada card usa (click) en un <div>, NO <label for>, para evitar que el radio reciba el
           click nativo. Cada método tiene su color de marca (payment-card--*), ver SCSS. -->
      <div class="col-12" [class.col-lg-7]="!pagoIniciado"
           [hidden]="pagoIniciado && (metodo_pago === 6 || metodo_pago === 7)">
        <p class="paso-titulo" *ngIf="!pagoIniciado"><span class="paso-titulo__num">1</span> Elige cómo quieres pagar</p>

        <div class="metodos-grid">

          <!-- Tarjeta (Stripe) -->
          <div *ngIf="habilitaStripe && (!pagoIniciado || metodo_pago === 6)" id="content-stripe"
               class="payment-card payment-card--tarjeta"
               [class.payment-card--active]="metodo_pago === 6 && metodoElegido"
               (click)="elegirMetodo(6)">
            <input id="FormaStripe" type="radio" [(ngModel)]="metodo_pago" [value]="6" name="radio" class="d-none">
            <span class="payment-card__radio" aria-hidden="true"><i class="fa fa-check"></i></span>
            <span class="payment-card__marca">
              <i class="fa fa-cc-visa" aria-hidden="true"></i>
              <i class="fa fa-cc-mastercard" aria-hidden="true"></i>
              <i class="fa fa-cc-amex" aria-hidden="true"></i>
            </span>
            <span class="payment-card__title">Tarjeta de crédito o débito</span>
          </div>

          <!-- OXXO -->
          <div *ngIf="habilitaOxxo && (!pagoIniciado || metodo_pago === 7)" id="content-oxxo"
               class="payment-card payment-card--oxxo"
               [class.payment-card--active]="metodo_pago === 7 && metodoElegido"
               (click)="elegirMetodo(7)">
            <input id="FormaOxxo" type="radio" [(ngModel)]="metodo_pago" [value]="7" name="radio" class="d-none">
            <span class="payment-card__radio" aria-hidden="true"><i class="fa fa-check"></i></span>
            <span class="payment-card__marca"><span class="logo-oxxo">OXXO</span></span>
            <span class="payment-card__title">Efectivo en OXXO</span>
            <span class="payment-card__desc">Pagas en la tienda</span>
          </div>

          <!-- SPEI -->
          <div *ngIf="habilitaSpei && (!pagoIniciado || metodo_pago === 8)" id="content-spei"
               class="payment-card payment-card--spei"
               [class.payment-card--active]="metodo_pago === 8 && metodoElegido"
               (click)="elegirMetodo(8)">
            <input id="FormaSpei" type="radio" [(ngModel)]="metodo_pago" [value]="8" name="radio" class="d-none">
            <span class="payment-card__radio" aria-hidden="true"><i class="fa fa-check"></i></span>
            <span class="payment-card__marca"><span class="logo-spei">SPEI</span></span>
            <span class="payment-card__title">Transferencia</span>
            <span class="payment-card__desc">Desde la app de tu banco</span>
          </div>

          <!-- PayPal -->
          <div *ngIf="habilitaPaypal && (!pagoIniciado || metodo_pago === 3)" id="content-pay"
               class="payment-card payment-card--paypal"
               [class.payment-card--active]="metodo_pago === 3 && metodoElegido"
               (click)="elegirMetodo(3)">
            <input id="FormaPaypal" type="radio" [(ngModel)]="metodo_pago" [value]="3" name="radio" class="d-none">
            <span class="payment-card__radio" aria-hidden="true"><i class="fa fa-check"></i></span>
            <span class="payment-card__marca">
              <img src="/assets/img/sorteo2024/paypal.png" alt="PayPal" class="payment-card__img">
            </span>
            <span class="payment-card__title">PayPal</span>
            <span class="payment-card__desc">Con tu cuenta PayPal</span>
          </div>

          <!-- Depósito / Referencia bancaria -->
          <div *ngIf="habilitarReferencia && (!pagoIniciado || metodo_pago === 2)" id="content-ref"
               class="payment-card payment-card--santander"
               [class.payment-card--active]="metodo_pago === 2 && metodoElegido"
               (click)="elegirMetodo(2)">
            <input id="FormaDeposito" type="radio" name="radio" [value]="2" [(ngModel)]="metodo_pago" class="d-none">
            <span class="payment-card__radio" aria-hidden="true"><i class="fa fa-check"></i></span>
            <span class="payment-card__marca">
              <img src="/assets/img/sorteo2023/logo-santander.png" alt="Santander" class="payment-card__img">
            </span>
            <span class="payment-card__title">Depósito bancario</span>
            <span class="payment-card__desc">Ventanilla o transferencia</span>
          </div>

          <!-- MIT -->
          <div *ngIf="habilitaMit && (!pagoIniciado || metodo_pago === 1)" id="content-mit"
               class="payment-card payment-card--mit"
               [class.payment-card--active]="metodo_pago === 1 && metodoElegido"
               (click)="elegirMetodo(1)">
            <input type="radio" id="FormaMIT" [(ngModel)]="metodo_pago" [value]="1" name="radio" class="d-none">
            <span class="payment-card__radio" aria-hidden="true"><i class="fa fa-check"></i></span>
            <span class="payment-card__marca">
              <img src="/assets/img/sorteo2024/tarjertas.png" alt="Visa / Mastercard" class="payment-card__img">
            </span>
            <span class="payment-card__title">Tarjeta bancaria</span>
          </div>

        </div>

        <!-- Requerido por el TS (ngOnInit hace getElementById y lo oculta) -->
        <a id="ctaMorePay" style="display:none"></a>
      </div>

      <!-- ===== PASO 2: RESUMEN + BOTÓN (derecha; en celular queda abajo) =====
           Boletos, total, método elegido y el ÚNICO botón que arranca el pago. -->
      <div class="col-12 col-lg-5" *ngIf="!pagoIniciado">
        <div class="resumen-pago" id="paso-confirmar">
          <p class="paso-titulo"><span class="paso-titulo__num">2</span> Revisa y paga</p>

          <div class="resumen-pago__boletos">
            <div class="resumen-pago__fila" *ngFor="let boleto of boletosResumen">
              <span>Boleto No. {{ boleto.folio }}</span>
              <span>$ {{ boleto.costo }}</span>
            </div>
            <div *ngIf="sinBoletos" class="resumen-pago__vacio">No hay boletos seleccionados.</div>
          </div>
          <div class="resumen-pago__total">
            <span>Total</span>
            <span>$ {{ total_compra }} MXN</span>
          </div>

          <div *ngIf="metodoElegido && INFO_METODOS[metodo_pago] as info"
               class="resumen-pago__metodo" [ngClass]="'resumen-pago__metodo--' + metodo_pago">
            <i class="fa {{ info.icono }}" aria-hidden="true"></i>
            <div>
              <strong>{{ info.nombre }}</strong>
              <small>{{ info.nota }}</small>
            </div>
          </div>

          <p *ngIf="urlWebPay.nb_response !== ''" class="resumen-pago__error">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i> El pago anterior no se completó. Intenta de nuevo.
          </p>

          <button type="button"
                  class="btn-stack border-0 btn-pay resumen-pago__boton"
                  (click)="continuarConMetodo()"
                  [disabled]="!metodoElegido || sinBoletos">
            <ng-container *ngIf="metodoElegido">{{ INFO_METODOS[metodo_pago]?.boton }}&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i></ng-container>
            <ng-container *ngIf="!metodoElegido">Primero elige una forma de pago</ng-container>
          </button>

          <p class="resumen-pago__seguro">
            <i class="fa fa-lock" aria-hidden="true"></i> No se cobra nada hasta que presiones el botón.
          </p>
        </div>
      </div>

      <!-- ===== CABECERA STRIPE ===== -->
      <div class="col-12" *ngIf="metodo_pago === 6 && pagoIniciado">
        <div class="stripe-active-header text-center">
          <div class="stripe-active-branding">
            <i class="fa fa-lock fa-2x stripe-lock-icon" aria-hidden="true"></i>
            <span class="stripe-active-title">Pago seguro con tarjeta</span>
          </div>
          <p class="stripe-active-cards">
            <i class="fa fa-cc-visa fa-lg" aria-hidden="true"></i>
            <i class="fa fa-cc-mastercard fa-lg" aria-hidden="true"></i>
            <i class="fa fa-cc-amex fa-lg" aria-hidden="true"></i>
            &nbsp;<i class="fa fa-shield" aria-hidden="true"></i>&nbsp;Encriptación SSL
          </p>
        </div>
      </div>

      <!-- ===== CABECERA SPEI ===== -->
      <div class="col-12" *ngIf="metodo_pago === 8 && pagoIniciado">
        <div class="stripe-active-header text-center">
          <div class="stripe-active-branding">
            <i class="fa fa-university fa-2x stripe-lock-icon" aria-hidden="true"></i>
            <span class="stripe-active-title">Pago por transferencia SPEI</span>
          </div>
          <p class="stripe-active-cards">Genera tu referencia y transfiere desde cualquier banco en línea</p>
        </div>
      </div>

      <!-- ===== CABECERA OXXO ===== -->
      <div class="col-12" *ngIf="metodo_pago === 7 && pagoIniciado">
        <div class="stripe-active-header text-center">
          <div class="stripe-active-branding">
            <i class="fa fa-barcode fa-2x stripe-lock-icon" aria-hidden="true"></i>
            <span class="stripe-active-title">Pago en tienda OXXO</span>
          </div>
          <p class="stripe-active-cards">Genera tu voucher y paga en cualquier tienda OXXO</p>
        </div>
      </div>

      <!-- ======================================================================
           LAYOUT OXXO: resumen de compra + datos del comprador pre-llenados.
           Se muestra un spinner mientras se genera el voucher; el modal no
           cerrable aparece cuando oxxoListo == true.
      ====================================================================== -->
      <ng-container *ngIf="metodo_pago === 7 && pagoIniciado">

        <div class="col-12 col-md-5 order-2 order-md-1 stripe-resumen">
          <h3 class="stripe-resumen__titulo">Resumen de compra</h3>

          <ng-container *ngIf="tipos_pago == 1">
            <div class="stripe-resumen__lista">
              <div class="stripe-resumen__fila" *ngFor="let boleto of boletos">
                <span>Boleto No. {{ boleto.folio }}</span>
                <span>$ {{ boleto.costo }} MXN</span>
              </div>
              <div *ngIf="boletos.length == 0" class="stripe-resumen__vacio">No se ha seleccionado ningún boleto.</div>
            </div>
            <div class="stripe-resumen__total"><span>Total</span><span>$ {{ total_compra }} MXN</span></div>
          </ng-container>

          <ng-container *ngIf="tipos_pago == 2 || tipos_pago == 3">
            <div class="stripe-resumen__lista">
              <div class="stripe-resumen__fila" *ngFor="let boleto of boletos_preAsignados.boletos">
                <span>Boleto No. {{ boleto.folio }}</span>
                <span>$ {{ boleto.costo }} MXN</span>
              </div>
            </div>
            <div class="stripe-resumen__total"><span>Total</span><span>$ {{ total_compra }} MXN</span></div>
          </ng-container>

          <p class="stripe-resumen__nota">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            Tu voucher OXXO se generará de forma automática con el nombre y correo del comprador registrado.
            Tendrás 3 días para realizar el pago en tienda.
          </p>
        </div>

        <div class="col-12 col-md-7 order-1 order-md-2 stripe-form-col">
          <p *ngIf="oxxoErrorMsg" class="text-danger stripe-error-msg mt-2">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ oxxoErrorMsg }}
          </p>
          <p class="text-muted" *ngIf="!oxxoListo && !oxxoErrorMsg">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i> Generando voucher OXXO...
          </p>
        </div>

      </ng-container>

      <!-- ======================================================================
           LAYOUT SPEI: resumen de compra + datos del comprador pre-llenados.
      ====================================================================== -->
      <ng-container *ngIf="metodo_pago === 8 && pagoIniciado">

        <div class="col-12 col-md-5 order-2 order-md-1 stripe-resumen">
          <h3 class="stripe-resumen__titulo">Resumen de compra</h3>

          <ng-container *ngIf="tipos_pago == 1">
            <div class="stripe-resumen__lista">
              <div class="stripe-resumen__fila" *ngFor="let boleto of boletos">
                <span>Boleto No. {{ boleto.folio }}</span>
                <span>$ {{ boleto.costo }} MXN</span>
              </div>
              <div *ngIf="boletos.length == 0" class="stripe-resumen__vacio">No se ha seleccionado ningún boleto.</div>
            </div>
            <div class="stripe-resumen__total"><span>Total</span><span>$ {{ total_compra }} MXN</span></div>
          </ng-container>

          <ng-container *ngIf="tipos_pago == 2 || tipos_pago == 3">
            <div class="stripe-resumen__lista">
              <div class="stripe-resumen__fila" *ngFor="let boleto of boletos_preAsignados.boletos">
                <span>Boleto No. {{ boleto.folio }}</span>
                <span>$ {{ boleto.costo }} MXN</span>
              </div>
            </div>
            <div class="stripe-resumen__total"><span>Total</span><span>$ {{ total_compra }} MXN</span></div>
          </ng-container>

          <p class="stripe-resumen__nota">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            Tu referencia SPEI se generará automáticamente. Tendrás 3 días para realizar la transferencia bancaria.
          </p>
        </div>

        <div class="col-12 col-md-7 order-1 order-md-2 stripe-form-col">
          <p *ngIf="speiErrorMsg" class="text-danger stripe-error-msg mt-2">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ speiErrorMsg }}
          </p>
          <p class="text-muted" *ngIf="!speiListo && !speiErrorMsg">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i> Generando referencia SPEI...
          </p>
        </div>

      </ng-container>

      <!-- ======================================================================
           LAYOUT STRIPE: dos columnas — izquierda resumen, derecha formulario.
           En móvil el formulario aparece primero (order-1) y el resumen debajo (order-2).
           El #stripe-payment-element SOLO existe aquí, nunca duplicado en otros layouts.
      ====================================================================== -->
      <ng-container *ngIf="metodo_pago === 6 && pagoIniciado">

        <!-- IZQUIERDA: resumen de compra -->
        <div class="col-12 col-md-5 order-2 order-md-1 stripe-resumen">

          <h3 class="stripe-resumen__titulo">Resumen de compra</h3>

          <!-- Boletos público general -->
          <ng-container *ngIf="tipos_pago == 1">
            <div class="stripe-resumen__lista">
              <div class="stripe-resumen__fila" *ngFor="let boleto of boletos">
                <span>Boleto No. {{ boleto.folio }}</span>
                <span>$ {{ boleto.costo }} MXN</span>
              </div>
              <div *ngIf="boletos.length == 0" class="stripe-resumen__vacio">
                No se ha seleccionado ningún boleto.
              </div>
            </div>
            <div class="stripe-resumen__total">
              <span>Total</span>
              <span>$ {{ total_compra }} MXN</span>
            </div>
          </ng-container>

          <!-- Boletos colaboradores -->
          <ng-container *ngIf="tipos_pago == 2 || tipos_pago == 3">
            <div class="stripe-resumen__lista">
              <div class="stripe-resumen__fila" *ngFor="let boleto of boletos_preAsignados.boletos">
                <span>Boleto No. {{ boleto.folio }}</span>
                <span>$ {{ boleto.costo }} MXN</span>
              </div>
              <div *ngIf="boletos_preAsignados.boletos.length == 0" class="stripe-resumen__vacio">
                No se ha seleccionado ningún boleto.
              </div>
            </div>
            <div class="stripe-resumen__total">
              <span>Total</span>
              <span>$ {{ total_compra }} MXN</span>
            </div>
          </ng-container>

          <p class="stripe-resumen__nota">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            Si vas a pagar desde Safari, verifica que tengas deshabilitadas las ventanas emergentes.
            <a href="https://www.youtube.com/shorts/XdR8SFZvABQ" target="_blank">Ver cómo</a>
          </p>
        </div>

        <!-- DERECHA: formulario Stripe -->
        <div class="col-12 col-md-7 order-1 order-md-2 stripe-form-col">
          <div id="stripe-payment-element" class="stripe-element-container"></div>
          <p *ngIf="stripeErrorMsg" class="text-danger stripe-error-msg mt-2">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ stripeErrorMsg }}
          </p>
          <button *ngIf="stripeFormularioCargado"
                  (click)="confirmarPagoStripe()"
                  class="btn-stack border-0 btn-pay stripe-pay-btn">
            <i class="fa fa-lock" aria-hidden="true"></i>&nbsp;Pagar con tarjeta
          </button>
        </div>

      </ng-container>

      <!-- ======================================================================
           LAYOUT OTROS MÉTODOS (MIT / PayPal / Banamex / Referencia)
           Solo visible cuando Stripe NO está activo.
      ====================================================================== -->
      <ng-container *ngIf="pagoIniciado && metodo_pago !== 6 && metodo_pago !== 7">

        <!-- Público General (tipos_pago == 1) -->
        <div *ngIf="tipos_pago == 1" class="col-lg-6 offset-lg-3 center" style="margin: auto">
          <h2 class="center title-tickets-select">
            <span id="cantboletos" [ngClass]="100 > this.boletos.length ? 'badge' : 'badgeG'">{{ boletos.length }}</span>
            Boleto(s) seleccionado(s):
          </h2>
          <div class="col-12 margen-t BoletosPay text-center">
            <div class="row" *ngFor="let boleto of boletos">
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 left">
                <label> No. {{ boleto.folio }} </label>
              </div>
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 right">
                <label> $ {{ boleto.costo }} MXN </label>
              </div>
            </div>
            <div class="row texto-primario" *ngIf="boletos.length == 0">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <label>No se ha seleccionado ningún boleto.</label>
              </div>
            </div>
            <hr class="hr-white" />
            <div class="row center">
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 left">
                <label class="text-uppercase"><b>Total</b></label>
              </div>
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 right">
                <label>$ {{ total_compra }} MXN</label>
              </div>
            </div>
          </div>

          <div class="col-12 text-center">
            <p>
              NOTA IMPORTANTE: Si vas a hacer tu pago por Safari, verifica que tengas deshabilitadas las ventanas
              emergentes (dar click en el enlace) en caso que este sea por cualquier otro navegador, continúa con tu pago
              sin problema.
              <a href="https://www.youtube.com/shorts/XdR8SFZvABQ" target="_blank"
                style="color: #ff5900; word-wrap: break-word;">https://www.youtube.com/shorts/XdR8SFZvABQ</a>
            </p>
          </div>

          <p *ngIf="pagoIniciado && metodo_pago === 3" class="paso-paypal">
            <i class="fa fa-hand-o-down" aria-hidden="true"></i>
            Último paso: presiona el botón amarillo de <strong>PayPal</strong> que aparece aquí abajo.
          </p>
          <div id="paypal-button-container" class="paypalForm" name="payplbtn" [hidden]="metodo_pago != 3"></div>
          <div id="banamex-button-container" class="paypalForm" name="banamexbtn" [hidden]="metodo_pago != 4"></div>
        </div>

        <!-- Referencia bancaria - Público General -->
        <div class="col-12 col-md-12 col-lg-4 margen-t center"
             *ngIf="tipos_pago == 1 && metodo_pago == 2 && pagoIniciado"
             [hidden]="!habilitarReferencia">
          <h2>Referencia bancaria</h2>
          <div class="col-12 margen-t BoletosPay margen-b">
            <!-- El botón "Generar referencia" ahora vive en el panel Paso 2 (continuarConMetodo). -->
            <p *ngIf="!mostrarReferencia" class="text-muted">
              <i class="fa fa-spin fa-spinner" aria-hidden="true"></i> Generando tu referencia, espera un momento...
            </p>
            <div *ngIf="mostrarReferencia" class="margen-t">
              <div class="margen-t margen-b">
                <p class="center">Banco:</p>
                <img style="width: 150px; margin-bottom: 10px" src="/assets/img/sorteo2023/logo-santander.png" />
                <br />
                <p class="center">Cuenta: {{ datos.cuenta }}</p>
                <p class="center">Convenio: {{ datos.convenio }}</p>
                <p class="center">CLABE: {{ datos.clabe }}</p>
                <h2 style="color:#333;">Para transferencia bancaria poner en campo "Concepto" la referencia</h2>
                <p class="center">Referencia: {{ datos.referencia }}</p>
                <p class="center" style="font-style: italic">
                  La referencia generada ha sido enviada a su email <span style="font-weight: bold"></span>.
                </p>
              </div>
              <label>Enviar a otro correo:</label>
              <div class="input-group col-xs-10">
                <input [(ngModel)]="correo_adicional" type="text" class="form-control email-add" />
                <span class="input-group-btn w-100">
                  <button (click)="reenviarCorreo()" class="btn-stack border-0" type="button"
                    [disabled]="correo_adicional == '' || enviando">Enviar</button>
                </span>
              </div>
              <p style="color: black">{{ envioTexto }}</p>
              <br />
              <button (click)="regresar()" class="btn-stack border-0">Terminar</button>
            </div>
          </div>
        </div>

        <!-- Colaboradores (tipos_pago == 2 o 3) -->
        <div *ngIf="tipos_pago == 2 || tipos_pago == 3"
          class="col-xs-12 col-sm-12 col-md-7 col-lg-6 col-xl-4 margen-t bloque3 center" id="boletos_seleccionados">
          <h2 class="text-uppercase">
            <span [ngClass]="100 > this.boletos_preAsignados.boletos.length ? 'badge' : 'badgeG'">{{
              boletos_preAsignados.boletos.length }}</span>
            Boleto(s) seleccionado(s)
          </h2>
          <div class="col-12 margen-t BoletosPay margen-b">
            <div class="row center" *ngFor="let boleto of boletos_preAsignados.boletos">
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 left">
                <label> No. {{ boleto.folio }} </label>
              </div>
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 right">
                <label> $ {{ boleto.costo }} MXN </label>
              </div>
            </div>
            <div class="row texto-primario" *ngIf="boletos_preAsignados.boletos.length == 0">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <label>No se ha seleccionado ningún boleto.</label>
              </div>
            </div>
            <hr class="hr-white" />
            <div class="row">
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label class="text-uppercase"> Total </label>
              </div>
              <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <label>$ {{ total_compra }} MXN</label>
              </div>
            </div>
          </div>
          <p *ngIf="pagoIniciado && metodo_pago === 3" class="paso-paypal">
            <i class="fa fa-hand-o-down" aria-hidden="true"></i>
            Último paso: presiona el botón amarillo de <strong>PayPal</strong> que aparece aquí abajo.
          </p>
          <div id="paypal-button-container" class="paypalForm" name="payplbtn" [hidden]="metodo_pago != 3"></div>
          <div id="banamex-button-container" class="paypalForm" name="banamexbtn" [hidden]="metodo_pago != 4"></div>
        </div>

        <!-- Referencia bancaria - Colaboradores -->
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 margen-t center"
          *ngIf="metodo_pago == 2 && pagoIniciado && (tipos_pago == 3 || tipos_pago == 2)" [hidden]="!habilitarReferencia">
          <h2>Referencia bancaria</h2>
          <div class="col-12 margen-t BoletosPay margen-b">
            <!-- El botón "Generar referencia" ahora vive en el panel Paso 2 (continuarConMetodo). -->
            <p *ngIf="!mostrarReferencia" class="text-muted">
              <i class="fa fa-spin fa-spinner" aria-hidden="true"></i> Generando tu referencia, espera un momento...
            </p>
            <div *ngIf="mostrarReferencia" class="margen-t">
              <div class="margen-t margen-b">
                <p class="center">Banco:</p>
                <img style="width: 150px; margin-bottom: 10px" src="/assets/img/sorteo2023/logo-santander.png" />
                <br />
                <p class="center">Cuenta: {{ datos.cuenta }}</p>
                <p class="center">Convenio: {{ datos.convenio }}</p>
                <p class="center">CLABE: {{ datos.clabe }}</p>
                <h2 style="color:#333;">Para transferencia bancaria poner en campo "Concepto" la referencia</h2>
                <p class="center">Referencia: {{ datos.referencia }}</p>
                <p class="center" style="font-style: italic">
                  La referencia generada ha sido enviada a su email <span style="font-weight: bold"></span>.
                </p>
              </div>
              <label>Enviar a otro correo:</label>
              <div class="input-group col-xs-10">
                <input [(ngModel)]="correo_adicional" type="text" class="form-control" />
                <span class="input-group-btn w-100 text-center">
                  <button (click)="reenviarCorreo()" class="btn-stack border-0 mt-3" type="button"
                    [disabled]="correo_adicional == '' || enviando">Enviar</button>
                </span>
              </div>
              <p style="color: black">{{ envioTexto }}</p>
              <br />
              <button (click)="regresar()" class="btn-stack border-0">Terminar</button>
            </div>
          </div>
        </div>

        <!-- ===== BOTÓN PAGAR (MIT / PayPal / Banamex) ===== -->
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="text-align: center"
          [hidden]="metodo_pago === 2">
          <div class="col-12 margen-t mrg">
            <!-- El botón de MIT ahora vive en el panel Paso 2 (continuarConMetodo). -->
            <p *ngIf="pagoIniciado && metodo_pago === 1" class="text-muted">
              <i class="fa fa-spin fa-spinner" aria-hidden="true"></i> Te estamos llevando a la página del banco...
            </p>
          </div>
          <div class="col-12 margen-t">
            <label *ngIf="urlWebPay.nb_response !== '' && metodo_pago == 1">El pago no pudo ser procesado, intente de
              nuevo.</label>
          </div>
        </div>

      </ng-container>

      <!-- Spinner (siempre en DOM, controlado por TS via spin.hidden) -->
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="text-align: center">
        <div class="spinnback" id="spin">
          <div class="spinn">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <br />
            <label style="color: whitesmoke; font-family: sofiaproregular">Espere por favor. <br />
              Procesando pago</label>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal fade" id="modalRedirigir" tabindex="-1" role="dialog" aria-labelledby="modalCompradores"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-body"></div>
    </div>
  </div>
</div>

<!-- Modal: Voucher SPEI (no cerrable — solo el botón "Cerrar" vuelve al home y limpia) -->
<div *ngIf="speiListo && speiVoucher"
     style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.75);z-index:10000;display:flex;align-items:center;justify-content:center;overflow-y:auto;">
  <div style="background:#fff;border-radius:12px;padding:32px 28px;max-width:520px;width:94%;text-align:center;box-shadow:0 8px 40px rgba(0,0,0,0.4);margin:24px auto;">

    <!-- Encabezado -->
    <div style="margin-bottom:20px;">
      <i class="fa fa-university fa-3x" style="color:#ff5900;" aria-hidden="true"></i>
      <h3 style="margin:12px 0 4px;font-size:1.4rem;">¡Referencia SPEI generada!</h3>
      <p style="color:#555;margin:0;">Realiza tu transferencia desde cualquier banco en línea o app bancaria.</p>
    </div>

    <!-- CLABE -->
    <div style="background:#f4f4f4;border:2px solid #ff5900;border-radius:8px;padding:16px;margin-bottom:16px;">
      <p style="font-size:0.8rem;color:#888;margin:0 0 4px;text-transform:uppercase;letter-spacing:1px;">CLABE interbancaria</p>
      <p style="font-size:1.55rem;font-weight:bold;letter-spacing:3px;color:#ff5900;margin:0;font-family:monospace;word-break:break-all;">
        {{ speiVoucher.clabe }}
      </p>
    </div>

    <!-- Datos de la transferencia -->
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:16px;text-align:left;">
      <div style="background:#f4f4f4;border-radius:8px;padding:10px 14px;">
        <p style="font-size:0.75rem;color:#888;margin:0 0 2px;">Banco</p>
        <p style="font-size:1rem;font-weight:bold;color:#333;margin:0;">{{ speiVoucher.bankName || 'STP' }}</p>
      </div>
      <div style="background:#f4f4f4;border-radius:8px;padding:10px 14px;">
        <p style="font-size:0.75rem;color:#888;margin:0 0 2px;">Beneficiario</p>
        <p style="font-size:1rem;font-weight:bold;color:#333;margin:0;">Sorteo Anáhuac</p>
      </div>
      <div style="background:#f4f4f4;border-radius:8px;padding:10px 14px;">
        <p style="font-size:0.75rem;color:#888;margin:0 0 2px;">Monto EXACTO</p>
        <p style="font-size:1.15rem;font-weight:bold;color:#ff5900;margin:0;">$ {{ speiVoucher.amount | number:'1.2-2' }} MXN</p>
      </div>
      <div style="background:#f4f4f4;border-radius:8px;padding:10px 14px;">
        <p style="font-size:0.75rem;color:#888;margin:0 0 2px;">Concepto</p>
        <p style="font-size:0.95rem;font-weight:bold;color:#333;margin:0;word-break:break-all;">{{ speiVoucher.referencia }}</p>
      </div>
    </div>

    <!-- Vencimiento -->
    <div style="background:#fff3cd;border-radius:8px;padding:10px 14px;margin-bottom:20px;text-align:left;">
      <p style="font-size:0.8rem;color:#888;margin:0 0 2px;">Paga antes del</p>
      <p style="font-size:0.95rem;font-weight:bold;color:#856404;margin:0;">
        {{ formatearFechaSpei(speiVoucher.expiresAt) || 'Ver instrucciones' }}
      </p>
    </div>

    <!-- Advertencia monto exacto -->
    <p style="font-size:0.8rem;color:#c0392b;margin:0 0 16px;">
      ⚠️ El monto debe ser <strong>exacto</strong>. Pagos con montos incorrectos pueden no acreditarse.
    </p>

    <!-- Botones -->
    <div style="display:flex;flex-direction:column;gap:10px;">
      <a *ngIf="speiVoucher.hostedInstructionsUrl"
         [href]="speiVoucher.hostedInstructionsUrl"
         target="_blank"
         style="display:block;background:#ff5900;color:#fff;border-radius:8px;padding:12px 24px;text-decoration:none;font-size:1rem;font-weight:600;">
        <i class="fa fa-external-link" aria-hidden="true"></i>&nbsp;Ver instrucciones completas
      </a>
      <button (click)="cerrarSpeiYRegresar()"
              style="background:#2c3e50;color:#fff;border:none;border-radius:8px;padding:12px 24px;font-size:1rem;font-weight:600;cursor:pointer;">
        <i class="fa fa-home" aria-hidden="true"></i>&nbsp;Cerrar y volver al inicio
      </button>
    </div>

    <p style="font-size:0.78rem;color:#999;margin-top:16px;margin-bottom:0;">
      Una vez que realices la transferencia, recibirás tu boleto por correo electrónico en minutos.
    </p>
  </div>
</div>

<!-- Modal: Voucher OXXO (no cerrable — solo el botón "Cerrar" vuelve al home y limpia) -->
<div *ngIf="oxxoListo && oxxoVoucher"
     style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.75);z-index:10000;display:flex;align-items:center;justify-content:center;overflow-y:auto;">
  <div style="background:#fff;border-radius:12px;padding:36px 32px;max-width:480px;width:92%;text-align:center;box-shadow:0 8px 40px rgba(0,0,0,0.4);margin:24px auto;">

    <!-- Encabezado -->
    <div style="margin-bottom:20px;">
      <i class="fa fa-check-circle fa-3x" style="color:#27ae60;" aria-hidden="true"></i>
      <h3 style="margin:12px 0 4px;font-size:1.4rem;">¡Voucher generado!</h3>
      <p style="color:#555;margin:0;">Lleva este número de referencia a cualquier tienda <strong>OXXO</strong> y realiza tu pago.</p>
    </div>

    <!-- Referencia -->
    <div style="background:#f4f4f4;border-radius:8px;padding:16px;margin-bottom:16px;">
      <p style="font-size:0.85rem;color:#888;margin:0 0 4px;">Número de referencia</p>
      <p style="font-size:1.8rem;font-weight:bold;letter-spacing:4px;color:#ff5900;margin:0;word-break:break-all;">
        {{ oxxoVoucher.referencia }}
      </p>
    </div>

    <!-- Monto y vencimiento -->
    <div style="display:flex;gap:12px;margin-bottom:20px;">
      <div style="flex:1;background:#f4f4f4;border-radius:8px;padding:12px;">
        <p style="font-size:0.8rem;color:#888;margin:0 0 4px;">Monto a pagar</p>
        <p style="font-size:1.2rem;font-weight:bold;color:#ff5900;margin:0;">$ {{ oxxoVoucher.amount | number:'1.2-2' }} MXN</p>
      </div>
      <div style="flex:1;background:#fff3cd;border-radius:8px;padding:12px;">
        <p style="font-size:0.8rem;color:#888;margin:0 0 4px;">Vence el</p>
        <p style="font-size:0.95rem;font-weight:bold;color:#856404;margin:0;">
          {{ formatearFechaOxxo(oxxoVoucher.expiresAt) || 'Ver voucher' }}
        </p>
      </div>
    </div>

    <!-- Botones -->
    <div style="display:flex;flex-direction:column;gap:10px;">
      <a *ngIf="oxxoVoucher.hostedVoucherUrl"
         [href]="oxxoVoucher.hostedVoucherUrl"
         target="_blank"
         style="display:block;background:#ff5900;color:#fff;border-radius:8px;padding:12px 24px;text-decoration:none;font-size:1rem;font-weight:600;">
        <i class="fa fa-print" aria-hidden="true"></i>&nbsp;Ver / Imprimir voucher
      </a>

      <button (click)="cerrarOxxoYRegresar()"
              style="background:#2c3e50;color:#fff;border:none;border-radius:8px;padding:12px 24px;font-size:1rem;font-weight:600;cursor:pointer;">
        <i class="fa fa-home" aria-hidden="true"></i>&nbsp;Cerrar y volver al inicio
      </button>
    </div>

    <p style="font-size:0.78rem;color:#999;margin-top:16px;margin-bottom:0;">
      Una vez que realices el pago, recibirás tu boleto por correo electrónico en minutos.
    </p>
  </div>
</div>

<!-- Modal: límite máximo por transacción (se cierra; la card no queda seleccionada) -->
<div *ngIf="modalLimite"
     style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(40,20,10,0.78);z-index:10000;display:flex;align-items:center;justify-content:center;padding:16px;">
  <div style="background:#fff;border-radius:14px;max-width:540px;width:100%;overflow:hidden;box-shadow:0 12px 40px rgba(0,0,0,0.45);border-top:6px solid #ff5900;">
    <div style="background:linear-gradient(135deg,#ff5900 0%,#fc5705 55%,#eb4d10 100%);padding:26px 24px 22px;text-align:center;">
      <div style="width:58px;height:58px;margin:0 auto 14px;border-radius:50%;background:rgba(255,255,255,0.22);display:flex;align-items:center;justify-content:center;">
        <span style="font-size:2rem;line-height:1;color:#fff;font-weight:bold;">!</span>
      </div>
      <h4 style="margin:0;font-size:1.3rem;color:#fff;font-weight:bold;line-height:1.3;">Límite máximo por transacción</h4>
    </div>
    <div style="padding:24px 26px 6px;text-align:left;">
      <div style="margin:0 0 12px;padding:12px 14px;background:#fff6f1;border-left:4px solid #ff5900;border-radius:6px;color:#4a4a4a;font-size:0.97rem;line-height:1.5;">
        El monto máximo por transacción es de <strong style="color:#eb4d10;">{{ limiteMontoMaximo | currency:'MXN':'symbol-narrow':'1.0-0' }}</strong>.
        Este total incluye todos los boletos de tu carrito.
      </div>
    </div>
    <div style="padding:14px 28px 30px;text-align:center;">
      <button type="button"
              style="min-width:200px;font-size:1.02rem;font-weight:bold;padding:13px 30px;color:#fff;background:#ff5900;border:0;border-radius:30px;cursor:pointer;box-shadow:0 4px 14px rgba(255,89,0,0.42);"
              (click)="modalLimite = false">
        Entendido
      </button>
      <p style="margin:16px 0 0;font-size:0.9rem;color:#666;">Regresa a tu carrito y quita boletos para continuar con tu compra.</p>
    </div>
  </div>
</div>

<!-- Modal: ¿Sigues ahí? -->
<div *ngIf="st.showWarningModal"
     style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.65);z-index:9999;display:flex;align-items:center;justify-content:center;">
  <div style="background:#fff;border-radius:10px;padding:36px 32px;max-width:420px;width:90%;text-align:center;box-shadow:0 6px 32px rgba(0,0,0,0.35);">
    <h4 style="margin-bottom:12px;font-size:1.4rem;">¿Sigues ahí?</h4>
    <p style="margin-bottom:8px;color:#555;">Tu sesión está por expirar. ¿Deseas continuar con tu compra?</p>
    <p style="font-size:2.5rem;font-weight:bold;margin-bottom:24px;color:#c0392b;">{{ st.modalCountdown }}</p>
    <button class="btn btn-primary" style="min-width:160px;font-size:1rem;padding:10px 24px;" (click)="st.continuarSesion()">
      Sigo aquí
    </button>
  </div>
</div>
